export const ROOT = '/';
export const DESCONEXION = '';
export const URL_ESTOY_SIN_LUZ = `${process.env.REACT_APP_URL_ESTOY_SIN_LUZ}`;
